import React from 'react';
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy
} from '@dnd-kit/sortable';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export const DroppableContainer = ({ id, items, children, closedContainer }) => {
  const {
    setNodeRef,
    isOver
  } = useSortable({
    id,
    data: { groupId: id, isClosed: closedContainer }
  });

  const containerClass = classNames('sui-w-full', {
    'sui-border-1': closedContainer,
    'sui-border-solid': closedContainer,
    'sui-px-2px': closedContainer,
    'sui-border-transparent': closedContainer && !isOver,
    'sui-border-strongest': closedContainer && isOver,
  });

  return (
    <SortableContext
      items={items}
      strategy={verticalListSortingStrategy}
    >
      <div
        className={containerClass}
        data-testid="group-container"
        ref={setNodeRef}
      >
        {
          children
        }
      </div>
    </SortableContext>
  );
};

DroppableContainer.displayName = 'DroppableContainer';

DroppableContainer.propTypes = {
  id: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node,
  closedContainer: PropTypes.bool
};

DroppableContainer.defaultProps = {
  children: null,
  closedContainer: false
};
